import { TextContent } from '@/resource/question/question.type';

const textExample = new TextContent(
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam',
);

export default textExample;
